import { cn } from "@/lib/utils";
import { ReactNode } from "react";

interface ProgressBarProps {
  value: number;
  totalValue: number;
  small?: boolean;
  label?: ReactNode;
}
const ProgressBar = ({
  value,
  totalValue,
  small = false,
  label,
}: ProgressBarProps) => {
  const percentage = (value / totalValue) * 100;
  return (
    <div
      className={cn(
        "relative min-w-16 w-full rounded-xl bg-white/20",
        small ? "h-2" : "h-4",
      )}
    >
      <div
        className="absolute h-full bg-progress-bar"
        style={{
          width: `${percentage}%`,
          borderRadius: percentage > 95 ? "0.75rem" : "0.75rem 0 0 0.75rem",
        }}
      />
      {label !== undefined && (
        <span className="absolute inset-0 flex items-center justify-center text-[11px] font-semibold leading-none text-white drop-shadow-[0_1px_1px_rgba(0,0,0,0.6)]">
          {label}
        </span>
      )}
    </div>
  );
};

export default ProgressBar;
